import React, { Component } from 'react';
import DriverCardView from './driver-card-view';
import {connect} from 'react-redux';
import { removeCurrentDriverCardOnMap } from '../available-drivers-map/available-drivers-map-actions';

class DriverCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <DriverCardView {...this.props}/>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  removeCurrentDriverCardOnMap: removeCurrentDriverCardOnMap
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverCard);



// WEBPACK FOOTER //
// ./src/components/map-markers/driver-card.js